import React, { useEffect, useState } from "react";
import parse, { domToReact } from "html-react-parser";
import { useDispatch, useSelector } from "react-redux";
import * as ConfigurationActions from "../../store/configurationService/actions";
import { ApplicationState } from "../../store";
import { removeEUPrivateShieldProvatePolicyLink } from "../../util/common";
import { sendRequest } from "../../util/httpClient";

const publicIp = require("public-ip");

interface IProps {
    showTemrsOfUseHeader?: boolean;
}
const TermsAndConditions: React.FunctionComponent<IProps> = (props) => {
    const dispatch = useDispatch();
    const [state, setState] = useState({ isLoading: true, content: "" });
    const ModuleCustomSettingsIds = { TermsAndConditions: 1347, CanadianTermsAndConditions: 12373 };
    const footerLogoHTML: any = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerProvider
            ? state.configurationState.configuration.partnerConfig.footerLogoHTML
            : ""
    );

    let authData = useSelector((state: ApplicationState) => {
        if (state.creditAuthData.authData != null) {
            return {
                isIDFUser: state.creditAuthData.authData.isIDFUser,
                partnerId: state.loggedInUser?.userInfo?.partnerID,
                status: state.creditAuthData.authData["status-code"],
            };
        }
        return { isIDFUser: "", partnerId: 36, status: "" };
    });
    const isIDFUser = useSelector((state: ApplicationState) => {
        if (state.configurationState && state.configurationState.configuration && state.configurationState.configuration.partnerConfig) {
            if (
                state.configurationState.configuration.partnerConfig.partnerId === 536 ||
                state.configurationState.configuration.partnerConfig.partnerProvider === "IDF"
            ) {
                return true;
            }
        } else {
            return false;
        }
    });
    const routeLoading = useSelector((state: ApplicationState) => state.configurationState && (state.configurationState.loading || false));
    const options = {
        replace: ({ attribs, children }: any) => {
            if (!attribs) return;

            if (attribs.hasOwnProperty("class")) {
                if (attribs.class.indexOf("pdfPrint_icons") !== -1) {
                    return (
                        <a href="javascript:window.print()">
                            <i className="las la-print" style={{ fontSize: "32px", float: "right" }}></i>
                        </a>
                    );
                }
            }

            if (attribs.hasOwnProperty("href")) {
                if (attribs.href.indexOf("window.print()") !== -1) {
                    return <a href="javascript:window.print();">{domToReact(children, options)}</a>;
                }

                if (attribs.href.indexOf("CommonDefinitions") !== -1 && isIDFUser === false)
                    return (
                        <a href="/common-definition" target="_blank">
                            {domToReact(children, options)}
                        </a>
                    );

                if (
                    attribs.href.indexOf("privacy-policy") !== -1 ||
                    attribs.href.indexOf("canadian-privacy-policy") !== -1 ||
                    attribs.href.indexOf("PrivacyPolicy") !== -1
                )
                    return (
                        <a href="/privacy" target="_blank">
                            {domToReact(children, options)}
                        </a>
                    );

                if (
                    attribs.href.indexOf("EU-USPrivacyShield") !== -1 ||
                    attribs.href.indexOf("EUUSPrivacyShield") !== -1 ||
                    attribs.href.indexOf("privacy-shield-policy") !== -1
                )
                    return (
                        <a href="/privacy-shield" target="_blank">
                            {domToReact(children, options)}
                        </a>
                    );

                if (attribs.href.indexOf("EUGDPRNotice") !== -1 || attribs.href.indexOf("eu-gdpr-fair-processing-notice") !== -1)
                    return (
                        <a href="/gdpr" target="_blank">
                            {domToReact(children, options)}
                        </a>
                    );

                if (attribs.href.indexOf("ccpa-addendum") !== -1 || attribs.href.indexOf("CCPAAddendum") !== -1)
                    return (
                        <a href="/ccpa" target="_blank">
                            {domToReact(children, options)}
                        </a>
                    );

                if (attribs.href.indexOf(window.location.hostname) === -1) {
                    if (attribs.id && attribs.id === "printTnC") {
                        return <a href="javascript:window.print()">{domToReact(children, options)}</a>;
                    } else {
                        return (
                            <a href={attribs.href} target="_blank" rel="noreferrer">
                                {domToReact(children, options)}
                            </a>
                        );
                    }
                }
            }
        },
    };

    const callAPI = (url: string, data: any): Promise<any> => {
        return sendRequest("POST", url, data, {
            PartnrID: data.PartnerID,
            ModuleCustomSettingsId: data.ModuleCustomSettingsId,
        }, true);
    };

    const isCanadianUser = (partnerId: any) => {
        const url = "api/CheckPartnerCountry/CheckPartnerCountry";
        const data: any = {};
        return callAPI(url, data).then((res: any): any => res.json());
    };

    const getUserGeoIpLocation = async (): Promise<any> => {
        const myIp = await publicIp.v4();
        return sendRequest("GET", "web/user/get-user-geo-location?ipAddress=" + myIp);
        return fetch("web/user/get-user-geo-location?ipAddress=" + myIp, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            },
        }).then((res: any): any => res.json());
    };

    const getPartnerCustomHtml = (data: any) => {
        const url = "api/GetPartnerCustomHtml/GetPartnerCustomHtml";
        callAPI(url, data)
            .then((res: any): any => res.json())
            .then((res: any): any => {
                if (res["hasError"] === false && res["legalDocuments"].length) {
                    setState({
                        isLoading: false,
                        content: removeEUPrivateShieldProvatePolicyLink(res["legalDocuments"][0].value),
                    });
                }
            })
            .catch((error: Error): any => console.log(error));
    };

    useEffect(() => {
        let data: any = {
            ModuleCustomSettingsId: ModuleCustomSettingsIds.TermsAndConditions,
        };

        if (isIDFUser) {
            //check if canadian user
            isCanadianUser(536)
                .then((res: any): any => {
                    if (res.isCanadianPartner) {
                        data = {
                            ModuleCustomSettingsId: ModuleCustomSettingsIds.CanadianTermsAndConditions,
                        };
                        getPartnerCustomHtml(data);
                    } else {
                        getUserGeoIpLocation()
                            .then((geoRes: any): any => {
                                const un_locode = geoRes["un_locode"];

                                if (un_locode != null && un_locode === "CA") {
                                    data = {
                                        ModuleCustomSettingsId: ModuleCustomSettingsIds.CanadianTermsAndConditions,
                                    };
                                }
                                getPartnerCustomHtml(data);
                            })
                            .catch((error: Error): any => {
                                getPartnerCustomHtml(data);
                            });
                    }
                })
                .catch((error: Error): any => {
                    getUserGeoIpLocation()
                        .then((geoRes: any): any => {
                            const un_locode = geoRes["un_locode"];

                            if (un_locode != null && un_locode === "CA") {
                                data = {
                                    ModuleCustomSettingsId: ModuleCustomSettingsIds.CanadianTermsAndConditions,
                                };
                            }
                            getPartnerCustomHtml(data);
                        })
                        .catch((error: Error): any => {
                            getPartnerCustomHtml(data);
                        });
                });
        } else {
            getPartnerCustomHtml(data);
        }
    }, [setState]);

    useEffect(() => {
        if (routeLoading) {
            dispatch(ConfigurationActions.actionCreators.setRouteLoading(false));
        }
    }, [dispatch, routeLoading]);

    return (
        <React.Fragment>
            <div className="faux-main-container">
                <div className=" row">
                    <div className="col-xs-12"></div>
                </div>

                <div className="row" id="content">
                    <div className="col-xs">
                        <div className="box box-has-shadow">
                            {state.isLoading ? (
                                <div className="box-content loading"></div>
                            ) : (
                                <div className="box-content">
                                    {props.showTemrsOfUseHeader && (
                                        <React.Fragment>
                                            {isIDFUser && <h2>Terms of Use</h2>}
                                            {!!authData && authData.status !== "200" && <h2>Terms of Use</h2>}
                                        </React.Fragment>
                                    )}
                                    {parse(state.content, options)}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                <div className="logo-container" dangerouslySetInnerHTML={{ __html: footerLogoHTML }}></div>
            </div>
        </React.Fragment>
    );
};

export default TermsAndConditions;
